import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/hooks/useTheme";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      title={`Switch to ${isDark ? "light" : "dark"} mode`}
      data-testid="theme-toggle-btn"
      className={`relative w-11 h-11 flex items-center justify-center border border-[rgb(var(--primary)/0.4)] text-[rgb(var(--accent))] hover:border-[rgb(var(--accent))] hover:bg-[rgb(var(--accent)/0.08)] transition-colors ${className}`}
    >
      <span
        className={`absolute inset-0 flex items-center justify-center transition-all duration-300 ${
          isDark ? "opacity-100 rotate-0 scale-100" : "opacity-0 -rotate-90 scale-75"
        }`}
      >
        <Sun size={16} strokeWidth={1.6} />
      </span>
      <span
        className={`absolute inset-0 flex items-center justify-center transition-all duration-300 ${
          isDark ? "opacity-0 rotate-90 scale-75" : "opacity-100 rotate-0 scale-100"
        }`}
      >
        <Moon size={16} strokeWidth={1.6} />
      </span>
      <span className="sr-only">Toggle theme</span>
    </button>
  );
}
